import React, { useState, useEffect } from 'react';
import { useTable, useSortBy, useGlobalFilter } from 'react-table';
import { Table, Container, Row, Col, Spinner, Pagination } from 'react-bootstrap';
import './Table.css';
import ChartCheckbox from '../Dashboard/Tools/ChartCheckbox';

const EditTableComponentPage4 = ({ columns, data, onSelectedRowsChange, selectedCheckbox, hiddenPagination, Pages, currentPage, onPageChange, loading }) => {
  const [checkedRows, setCheckedRows] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [topCheck, setTopCheck] = useState(true);
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy
  );

  useEffect(() => {
    if (onSelectedRowsChange) {
      onSelectedRowsChange(selectedRows);
    }
  }, [selectedRows, onSelectedRowsChange]);

  useEffect(() => {
    if (selectedCheckbox && selectedCheckbox.length > 0) {
      // Set initially checked rows
      const initialChecked = {};
      selectedCheckbox.forEach((row) => {
        const rowIndex = data.findIndex(item => item.id === row.id); // Assuming `id` is the unique identifier
        if (rowIndex !== -1) {
          initialChecked[rowIndex] = true;
        }
      });
      setCheckedRows(initialChecked);
      setSelectedRows(selectedCheckbox);
    }
  }, [selectedCheckbox, data]);

  const handleCheckboxChange = (rowIndex, rowData) => {
    setCheckedRows((prevState) => {
      const updatedCheckedRows = { ...prevState, [rowIndex]: !prevState[rowIndex] };
      const updatedSelectedRows = Object.keys(updatedCheckedRows)
        .filter(index => updatedCheckedRows[index])
        .map(index => data[index]);

      setSelectedRows(updatedSelectedRows);
      return updatedCheckedRows;
    });
  };

  const handleDeCheckAll = () => {
    setTopCheck(!topCheck);
  };

  const handleNextPage = () => {
    if (currentPage < Pages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <Container className="mb-0 pb-0">
      <Row className='justify-content-end mb-2'>
        {!hiddenPagination ? (
          <Col lg={3} md={4} sm={6}>
            <div className='d-flex align-items-center gap-2'>
              <span style={{ fontSize: "14px", color: "#94a3b8" }}>Show</span>
              <select name="10" id="" style={{
                outline: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                color: "#94a3b8",
                borderRadius: '3px',
                fontSize: '16px'
              }}>
                <option value="hello">10</option>
              </select>
              <span style={{ fontSize: "14px", color: "#94a3b8" }}>Per Page</span>
            </div>
          </Col>
        ) : (<></>)}
      </Row>
      <div className='table-container'>
        <Table {...getTableProps()} striped bordered hover className='pb-0 mb-2'>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                <th style={{ maxWidth: 45, backgroundColor: '#292d2e', color: '#f8f9fa', padding: '5px', alignItems: "center" }}>
                  <ChartCheckbox label='' onChange={handleDeCheckAll} initialChecked={true} size='13px' />
                </th>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="text-center position-relative"
                    style={{
                      backgroundColor: '#292d2e',
                      color: '#f8f9fa',
                      fontSize: "10px",
                      overflow: 'visible',
                      minWidth: 'max-content',
                      padding: '5px',
                      lineHeight: 'normal',
                      verticalAlign: 'middle',
                      width: `calc((100% - 50px) / ${headerGroup.headers.length})`,
                    }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loading ? (
              <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </td>
              </tr>
            ) : rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row);
                var isRowChecked = checkedRows[i] || false;
                return (
                  <tr
                    {...row.getRowProps()}
                    className={isRowChecked ? 'checked-col' : ''}
                  >
                    <td style={{ maxWidth: 45 }} className='check-table'>
                      <ChartCheckbox
                        initialChecked={isRowChecked}
                        label=''
                        size='13px'
                        onChange={() => handleCheckboxChange(i, row.original)}
                      />
                    </td>
                    {row.cells.map(cell => (
                      <td {...cell.getCellProps()} style={{ textAlign: 'center' }}>
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {!hiddenPagination ? (
        <div className='pagination-table-com'>
          <Pagination>
            <Pagination.Prev onClick={handlePrevPage} disabled={currentPage === 1} />
            {[...Array(Pages).keys()].map(page => (
              <Pagination.Item
                key={page + 1}
                active={page + 1 === currentPage}
                onClick={() => onPageChange(page + 1)}
              >
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={handleNextPage} disabled={currentPage === Pages} />
          </Pagination>
        </div>
      ) : (<></>)}
    </Container>
  );
};

export default EditTableComponentPage4;
